import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10cd4a0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-hidden", "data-height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "welcome-message__logo" }, null, -1))
const _hoisted_3 = { class: "welcome-message__content" }
const _hoisted_4 = { class: "welcome-message__title" }
const _hoisted_5 = {
  key: 0,
  class: "welcome-message__message"
}
const _hoisted_6 = ["disabled"]

import { ref } from 'vue'
import locales from './WelcomeMessage.locales.en.json'
import XCircleIcon from '@/icons/XCircleIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeMessage',
  setup(__props) {

const closed = ref(false)
const containerHeight = ref(0)

function handleClose() {
  closed.value = true
}

return (_ctx: any,_cache: any) => {
  return (!closed.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "element",
        class: "welcome-message",
        role: "alert",
        "aria-hidden": closed.value,
        "data-height": containerHeight.value
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(locales).title), 1),
          (_unref(locales).message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(locales).message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "welcome-message__button",
            disabled: closed.value,
            onClick: handleClose
          }, [
            _createVNode(XCircleIcon, { "aria-label": "Close Welcome Message" })
          ], 8, _hoisted_6)
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})